import wejs from 'weui.js'
import { apiTimeout } from '@/config/net'

function loadingTools (setTimeOut = null) {
  let handler = null
  let noLoadingDev = false // 调试时可以关闭loading功能
  let timeOutHandler = null
  let timeOut = setTimeOut || apiTimeout // loading超时
  let loadingText = '加载中' // loading显示文字
  let delayLoading = 200 // loading延迟
  let delayLoadingHandler = null
  let loadingCounter = 0
  let WeLoading = function () {}
  WeLoading.loading = function () {
    if (noLoadingDev) return
    loadingCounter++
    // 有请求就重新计时
    clearTimeout(delayLoadingHandler)
    delayLoadingHandler = setTimeout(function () {
      handler = wejs.loading(loadingText)
    }, delayLoading)
    // 每次清理熔断器，只保护最后一个请求
    clearTimeout(timeOutHandler)
    timeOutHandler = setTimeout(function () {
      // 熔断
      loadingCounter = 0
      if (handler) handler.hide()
    }, timeOut)
  }
  WeLoading.hide = function () {
    if (noLoadingDev) return
    loadingCounter--
    if (loadingCounter > 0) return
    loadingCounter = 0
    // 正常关闭，清理熔断器
    clearTimeout(delayLoadingHandler)
    clearTimeout(timeOutHandler)
    if (handler) handler.hide()
  }
  return WeLoading
}

export default loadingTools



// WEBPACK FOOTER //
// ./src/tools/loading.js